module.exports = __webpack_public_path__ + "static/img/logo2.fa106f70.jpg";